import React from 'react'

import { CheckboxLogic, SelectableBoxView, SelectableBoxViewProps } from 'components/_new/controls'


type SelectableBoxProps = {
  active?: boolean
  disabled?: boolean
  ariaLabel: string | ReactIntlMessage
  onChange: (checked: boolean) => void
} &
  Pick<SelectableBoxViewProps,
    'className'
    | 'tag'
    | 'icon'
    | 'iconColor'
    | 'iconPosition'
    | 'withBg'
    | 'fullWidth'
    | 'active'
    | 'dataTestId'
    | 'isFetching'
  >

const SelectableBox: React.FunctionComponent<SelectableBoxProps> = (props) => {
  const {
    className, active,
    // CheckboxLogic
    children, disabled, ariaLabel, onChange,
    // SelectableBoxView
    tag, icon, iconColor, iconPosition,
    withBg, fullWidth, isFetching,
    dataTestId,
  } = props

  const selectableBoxProps = {
    className,
    tag,
    icon,
    iconColor,
    iconPosition,
    withBg,
    fullWidth,
    isFetching,
    active,
    dataTestId,
  }

  return (
    <CheckboxLogic
      disabled={disabled}
      checked={active}
      ariaLabel={ariaLabel}
      onChange={onChange}
    >
      {
        ({ isChecked }) => (
          <SelectableBoxView {...selectableBoxProps} active={isChecked}>
            {typeof children === 'function' ? children({ isChecked }) : children}
          </SelectableBoxView>
        )
      }
    </CheckboxLogic>
  )
}


export default SelectableBox
